import { Component, OnInit } from '@angular/core';
import { RestService } from "app/webservice/rest.service";
import { GridMetadataService } from '../clearwave-grid/grid.metadata.service';
import { environment } from "environments/environment";
import { PlatformLocation } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { LookupService } from 'app/webservice/lookup.service';

@Component({
  selector: 'spine-label',
  templateUrl: './spine-label.component.html',
  styleUrls: ['./spine-label.component.css']
})
export class SpineLabelComponent implements OnInit {
  
  public serviceStackUrl;
  public loading: boolean = false;
  public SpineLabels;
  public media = {
    lkpAssetTypeOidList: []
  };
  public results = [];
  public numResults;
  public assetTypes = [];
  public type;
  public selectedRows = [];

  constructor(
    private route: ActivatedRoute, 
    private _lookup: LookupService,
    private _restService: RestService, 
    private _gridMetadataService: GridMetadataService,
    private _router: Router,
    platformLocation: PlatformLocation
  ) {
    this.loading = true;
    this.serviceStackUrl = (platformLocation as any).location.origin + '/CCLibrary/api/';
    
    this.assetTypes = this._lookup.findLookupByLookupName('AssetType');
    for (var i = this.assetTypes.length - 1; i >= 0; i--) {
      if (this.assetTypes[i].Value === "Video") {
        this.assetTypes[i].Value = 'DVD';
      }
    }
    
    this.SpineLabels = this._gridMetadataService.describe('SpineLabels', null);
    this.SpineLabels.forceFitColumns = true;
    this.SpineLabels.height = -300;
    this.SpineLabels.completeGridEditDisabled = true;
    this.SpineLabels.disableRest = true;
    this.SpineLabels.onSelectedRowsChanged = this.setSelectedRows.bind(this);
    
    this.route.params.subscribe(params => {
      if (params['Type']) {
        console.log(params['Type']);
        console.log(this.assetTypes);
        let found = this.assetTypes.filter((result) => {
          return (result.Value == params['Type']);
        });

        if (found[0]) {
          this.media.lkpAssetTypeOidList.push(found[0].Oid);
          this.type = params['Type'];
          console.log(this.media);
        }
        console.log(found);

        let url = this.serviceStackUrl + "Asset-GetAssetsByQuery";
      
        console.log(this.media);
        this._restService.post(url, {Query: this.media}).then(response => {
          this.loading = false;
          this.results = response.Data;
          this.numResults = this.results.length;
          console.log(this.results);
          if (this.numResults) {
            this.SpineLabels.data = this.results;
            this.SpineLabels.title = this.numResults + ' Item(s)';
            if (typeof this.SpineLabels.setData === "function") {
              this.SpineLabels.setData(this.results);
            }
          }
        })
      }
    });

    
  }

  ngOnInit() {
  
  }

  setSelectedRows(e, args) {
    this.selectedRows = [];
    for (let row of args.rows) {
      this.selectedRows.push(args.grid.getDataItem(row).IdNumber);
    }
  }

  printLabels() {
    if (this.selectedRows.length) {
      console.log(this.selectedRows);
      this._router.navigate(['/printspinelabels/', { rows: this.selectedRows }]);
    }
  }

}



// WEBPACK FOOTER //
// c:/Projects/CCLibrary/Client/src/app/spine-label/spine-label.component.ts